var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricDenies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9684)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9684)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8021_9684)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8021_9684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H4V19H19V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8021_9684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.634 14.2927C15.343 14.2927 14.2949 15.3427 14.2949 16.6337C14.2949 17.9255 15.343 18.9746 16.634 18.9746C17.9249 18.9746 18.974 17.9255 18.974 16.6337C18.974 15.3427 17.9249 14.2927 16.634 14.2927ZM15.0937 16.8024C15.0937 15.848 15.8587 15.0746 16.7999 15.0746C17.0699 15.0746 17.3315 15.1393 17.5687 15.2602L15.2784 17.5805C15.1574 17.3396 15.0937 17.0724 15.0937 16.8024ZM16.4943 18.2124C16.2599 18.2124 16.033 18.1609 15.8165 18.0634L18.0449 15.804C18.1415 16.0233 18.194 16.2577 18.194 16.493C18.1949 17.4399 17.4318 18.2124 16.4943 18.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4879 9.6709C10.4473 9.6709 9.60352 10.4912 9.60352 11.5037C9.60352 12.5153 10.4473 13.3356 11.4879 13.3356C12.5266 13.3356 13.3713 12.5153 13.3713 11.5037C13.3713 10.4912 12.5276 9.6709 11.4879 9.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2612 16.6553C13.2612 14.7906 14.7828 13.2766 16.6578 13.2766C17.3843 13.2766 18.0537 13.5081 18.6059 13.8944C18.8571 13.15 18.9996 12.355 18.9996 11.5272C18.9996 7.40595 15.6443 4.0647 11.5071 4.0647C7.36902 4.0647 4.01465 7.40595 4.01465 11.5272C4.01465 15.6484 7.36902 18.9897 11.5071 18.9897C12.3387 18.9897 13.1365 18.8463 13.8837 18.5959C13.4937 18.0456 13.2612 17.3791 13.2612 16.6553ZM15.6462 6.59876L16.4393 7.39095L14.764 9.0672L13.9718 8.27501L15.6462 6.59876ZM7.3259 16.5044L6.53371 15.7122L8.20996 14.0359L9.00215 14.8291L7.3259 16.5044ZM8.68715 11.5004C8.68715 9.94639 9.94642 8.68751 11.4992 8.68751C13.052 8.68751 14.3121 9.94727 14.3121 11.5004C14.3121 13.0536 13.052 14.3125 11.4992 14.3125C9.94642 14.3125 8.68715 13.0536 8.68715 11.5004Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9684",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricDenies);
export default __webpack_public_path__ + "static/media/Metric-Denies.1eb3c243f6d3b155f61f94e770525127.svg";
export { ForwardRef as ReactComponent };